import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { StockInService } from './stock-in.service';
import {getAllStockInDetailsResponseModel, GetReportedPalletsResponseModel, ReportingStockDto, SaleOrderIdRequest, StockInReportResponseDto, StockInReportResponseModel, StockInRequestDto, StockInResponseModel, StockInVerfication, StockOutResponse, SuggestPalletResponseModel, SuggestPalletTypeResponseModel, WarehouseDashboardResponseModel} from '@gtpl/shared-models/warehouse-management';
import { StockInDto } from './dto/stock-in.dto';
import { SuggestPalletRequest } from './dto/suggest-pallet.request';
import { ReportedStockRequest } from './dto/reported-stock.request';
import { PalletRequest } from './dto/pallet.request';
import { InputIdRequest } from '../stock/dto/input-id.request';
import { SaleOrderItemsBySoIdReaponseModel } from '@gtpl/shared-models/sale-management';
import { StockInRequest } from 'libs/shared-services/warehouse-management/src/lib/stock-in.request';
import { StockinPrintResponseModel } from 'libs/shared-services/warehouse-management/src/lib/stock-in-print-resonsemodel';
import { StockInPrintRequest } from './dto/stockin-print-request';
import { CommonResponse, PlantIdRequest } from '@gtpl/shared-models/masters';
@ApiTags('Stock In')
@Controller('stock-in')
export class StockInController {
    constructor(
        private stockInService: StockInService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
      /**
       * 
       * @param stockInDto 
       * @param isUpdate 
       * @param request 
       * @returns 
       */
      @Post('/reportStockIn')
      async reportStockIn(@Body() stockInDto:StockInDto,isUpdate:boolean=false): Promise<StockInResponseModel> {
          try {
              return await this.stockInService.reportStockIn(stockInDto, false);
          } catch (error) {
              return this.applicationExceptionhandler.returnException(StockInResponseModel, error)
          }
      }
      /**
       * 
       * @param stockInDto 
       * @param isUpdate 
       * @param request 
       * @returns 
       */
      @Post('/reportStockData')
      async reportStockData(@Body() stockInDto:StockInDto,isUpdate:boolean=false,@Req() request:Request): Promise<StockInResponseModel> {
          try {
              return await this.stockInService.reportStockData(stockInDto, false,request);
          } catch (error) {
              return this.applicationExceptionhandler.returnException(StockInResponseModel, error)
          }
      }
      @Post('/reportStock')
      async reportStock(@Body() stockInDto: StockInRequestDto): Promise<StockInReportResponseModel> 
        {
          try {
              return await this.stockInService.reportStock(stockInDto, stockInDto.isUpdate);
          } catch (error) {
              return this.applicationExceptionhandler.returnException(StockInReportResponseModel, error)
          }
      }
      @Post('/getReportedStockBySoId')
    async getReportedStockBySoId(@Body() reportedStockRequest: ReportedStockRequest): Promise<GetReportedPalletsResponseModel> {
        try {
          console.log(reportedStockRequest);
         return await this.stockInService.getReportedStockBySoId(reportedStockRequest);
       } catch (error) {
            return this.applicationExceptionhandler.returnException(GetReportedPalletsResponseModel, error);
       }
     }
      @Post('/suggestPallet')
      async suggestPallet(@Body() suggestPalletRequest:SuggestPalletRequest): Promise<SuggestPalletResponseModel> {
          try {
              return await this.stockInService.suggestPallet(suggestPalletRequest);
          } catch (error) {
              return this.applicationExceptionhandler.returnException(SuggestPalletResponseModel, error)
          }
      }
      @Post('/suggestPalletType')
      async suggestPalletType(@Body() suggestPalletRequest:SuggestPalletRequest): Promise<SuggestPalletTypeResponseModel> {
          try {
              return await this.stockInService.suggestPalletType(suggestPalletRequest);
          } catch (error) {
              return this.applicationExceptionhandler.returnException(SuggestPalletTypeResponseModel, error)
          }
      }
      @Post('/checkPalletAvailability')
      async checkPalletAvailability(@Body() palletRequest:PalletRequest): Promise<boolean> {
          try {
              return await this.stockInService.checkPalletAvailability(palletRequest);
          } catch (error) {
            //   return this.applicationExceptionhandler.returnException(Boolean, error)
          }
      }

      /**
     * get product details for a pallet relared sale order item id
     * @param req 
     * @returns 
     */

     @Post('/productDetailsForPalletId')
     async productDetailsForPalletId(@Body() req:InputIdRequest):Promise<SaleOrderItemsBySoIdReaponseModel>{
       try {
         return await this.stockInService.productDetailsForPalletId(req);
       } catch (error) {
         return this.applicationExceptionhandler.returnException(SaleOrderItemsBySoIdReaponseModel, error);
       }
     }
     @Post('/getReportedStockForSoId')
    async getReportedStockForSoId(@Body() req: SaleOrderIdRequest):Promise<getAllStockInDetailsResponseModel> {
       try {
         console.log(req);
         return await this.stockInService.getReportedStockForSoId(req);
       } catch (error) {
         return this.applicationExceptionhandler.returnException(getAllStockInDetailsResponseModel, error);
       }
     }
    @Post('/reverseStockIn')
    async reverseStockIn(@Body() req: StockInRequest): Promise<WarehouseDashboardResponseModel> {
      try {
        return await this.stockInService.reverseStockIn(req);
      } catch (error) {
        return this.applicationExceptionhandler.returnException(WarehouseDashboardResponseModel, error);
      }
    }


    @Post('/getStockInPrint')
    async getStockInPrint(@Body()req:StockInPrintRequest):Promise<StockinPrintResponseModel>{
      try{
        return await this.stockInService.getStockInPrint(req);

      }catch(err){
        return this.applicationExceptionhandler.returnException(StockinPrintResponseModel,err);
      }
    }

    @Post('/reportStockInData')
    async reportStockInData(@Body() stockInDto: ReportingStockDto, isUpdate: boolean): Promise<CommonResponse> {
      try{
        return await this.stockInService.reportStockInData(stockInDto, isUpdate);
      }catch(err){
        return this.applicationExceptionhandler.returnException(CommonResponse,err);
      }
    }

    
    @Post('/stockPlacementVerification')
    async stockPlacementVerification(@Body() req: StockInVerfication): Promise<CommonResponse> {
      try{
        return await this.stockInService.stockPlacementVerification(req);
      }catch(err){
        return this.applicationExceptionhandler.returnException(CommonResponse,err);
      }
    }

    @Post('/getPalletsVerificationDropDown')
    async getPalletsVerificationDropDown(@Body() req:PlantIdRequest):Promise<CommonResponse>{
      try{
        return await this.stockInService.getPalletsVerificationDropDown(req);
      }catch(err){
        return this.applicationExceptionhandler.returnException(CommonResponse,err);
      }
    }


}


